module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp3_5.b4b35b87.png";